import { Box, Text, Flex, Image } from "@chakra-ui/react";
import UnIcon from "./assets/un.png";
import GoIcon from "./assets/go.png";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";

const Unverified = () => {
  const navigate = useNavigate();
  const { bridgeCustomer } = useUserInfo();
  return (
    <Flex
      onClick={() => {
        if (bridgeCustomer.id) {
          navigate("/verifyInfo");
        } else {
          navigate("/createKyc");
        }
      }}
      sx={{
        width: "100%",
        height: "170px",
        background: "#BBBBBB",
        borderRadius: "10px",
        overflow: "hidden",
        paddingTop: "16px",
      }}
      flexDir={"column"}
      align={"center"}
    >
      <Text
        sx={{
          color: "#848484",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "14px",
          fontWeight: 900,
        }}
      >
        Bank Account
      </Text>
      <Image
        src={UnIcon}
        sx={{
          width: "33px",
          marginTop: "20px",
        }}
      ></Image>{" "}
      <Text
        sx={{
          color: "#848484",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 900,
          marginTop: "5px",
        }}
      >
        Unverified
      </Text>
      <Flex
        sx={{
          marginTop: "auto",
          background: "#FFC773",
          height: "32px",
          padding: "0 30px",
        }}
        align={"center"}
        justify={"space-between"}
        width={"100%"}
      >
        <Text
          sx={{
            color: "#D8762B",
            fontSize: "14px",
            fontWeight: 700,
          }}
        >
          Start Verification
        </Text>
        <Image
          src={GoIcon}
          sx={{
            width: "16px",
          }}
        ></Image>
      </Flex>
    </Flex>
  );
};

export default Unverified;
